import { render, staticRenderFns } from "./ArticleGenerate.vue?vue&type=template&id=5ccdd6c7&scoped=true"
import script from "./ArticleGenerate.vue?vue&type=script&lang=js"
export * from "./ArticleGenerate.vue?vue&type=script&lang=js"
import style0 from "./ArticleGenerate.vue?vue&type=style&index=0&id=5ccdd6c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccdd6c7",
  null
  
)

export default component.exports